import React from 'react';

import { CarSearchInputFieldsProps } from './CarSearchInput';

import { VStack, Box, Text, Input } from '@wegroup/design-system';
import LicenseInputEU from '../../legacy/LicenseInputEU';

const CarSearchInputFields: React.FC<
  React.PropsWithChildren<CarSearchInputFieldsProps>
> = ({
  onSearch,
  example,

  // Status
  warning,
  disabled,

  // Value
  value,
  setValue,

  // Input
  inputPattern,
  inputMaxLength,
  validationError,

  // Bools
  isNumberPlate,
}) => {
  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (disabled) return;
    const code = e.keyCode || e.which;
    if (code === 13) {
      onSearch(value);
    }
  };

  return (
    <Box w="100%">
      {isNumberPlate ? (
        <LicenseInputEU
          maxW="100%"
          countryCode="NL"
          bg="yellow.400"
          height="14"
          onChange={(e) => {
            const currentTarget = e.currentTarget as HTMLInputElement;
            setValue(currentTarget.value?.toUpperCase());
          }}
          onKeyPress={handleKeyPress}
          value={value}
        />
      ) : (
        <Input
          data-test-id="Common_VinSearchInput_Input"
          onChange={({ currentTarget: { value } }) =>
            setValue(value?.toUpperCase())
          }
          onKeyPress={handleKeyPress}
          value={value}
          type="text"
          pattern={inputPattern}
          maxLength={inputMaxLength}
          // Styling
          flex="1"
          w="100%"
          border="1px solid"
          borderColor={warning ? 'danger.main' : 'gray.100'}
          borderRadius="md"
          textStyle="largeBodyBold"
          textTransform="uppercase"
          fontSize="2xl"
          textAlign="center"
          height="14"
          bg="white"
        />
      )}

      <VStack
        mt="2"
        justifyContent="space-between"
        alignItems="flex-start"
        sx={{
          '@media print': {
            display: 'none',
          },
        }}
      >
        <Text textStyle="smallBody" color="text.gray">
          {example}
        </Text>
        {warning ? (
          <Text textStyle="smallBody" color="danger.main">
            {warning}
          </Text>
        ) : (
          validationError &&
          (typeof validationError === 'string' ? (
            <Text textStyle="smallBody" color="text.gray">
              {validationError}
            </Text>
          ) : (
            validationError
          ))
        )}
      </VStack>
    </Box>
  );
};

export default CarSearchInputFields;
